import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { isTokenExpiredOrNull } from "../../../utils/auth";
import { useAuthContext } from "src/contexts/AuthContext";
import { LoadingSpinner } from "src/components";
import { SpinnerContainer } from "src/pages/Allocations-V2/Tables/AllocationTableBody/AllocationTableBody.styles";
import { Box } from "@mui/material";

interface AuthProps {
  children: JSX.Element;
  redirectUrl?: string;
}

const withAuthHandler = (WrappedComponent: any, redirectUrl = "/login") => {
  const Wrapper: React.FC<AuthProps> = (props) => {
    const { user } = useAuthContext();
    let { children } = props;

    const [loading, setLoading] = useState(true);
    const router = useRouter();

    useEffect(() => {
      var isExpiredOrNull = isTokenExpiredOrNull();
      if (user) {
        if (isExpiredOrNull) {
          router.replace({
            pathname: redirectUrl,
            query: { redirectUrl: router.asPath },
          });
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
        router.replace({
          pathname: redirectUrl,
          query: { redirectUrl: router.asPath }
        });
      }
    }, [user]);


    if (loading) {
      return (
        <Box sx={{ height: "100vh" }}>
          <SpinnerContainer>
            <LoadingSpinner color="inherit"/>;
          </SpinnerContainer>
        </Box>
      )
    }

    return (
      <WrappedComponent {...props}>
        {children}
      </WrappedComponent>
    );
  };

  return Wrapper;
};

export default withAuthHandler;
